import type { HelperTabKey } from '../../services/helper/helperStore'

export const HELPER_ALREADY_MOUNTED_GUIDES = [
  'helper.overview',
  'helper.incoming-invites',
  'helper.profile',
  'helper.settings',
] as const

export const HELPER_TAB_SCREEN_GUIDES: Record<HelperTabKey, string | undefined> = {
  TASKS: 'helper.tasks',
  CALENDAR: 'helper.calendar',
  MEETINGS: 'helper.meetings',
  CHAT: 'helper.chat',
  FIELD: 'helper.controls',
  SCHOOL: 'helper.school',
  OPS: undefined,
}

export const helperScreenGuideId = (
  activeTab: HelperTabKey | string | null | undefined,
): string | undefined => {
  if (!activeTab) return undefined
  const normalized = activeTab.toUpperCase() as HelperTabKey
  return HELPER_TAB_SCREEN_GUIDES[normalized]
}
